import flatten from 'lodash.flatten';
import mapValues from 'lodash.mapvalues';
import qs from 'qs';

export function parseQueryString(
  win: { location: { href: string } } = window,
): Record<string, string[]> {
  return parseURL(win.location.href);
}

export function parseURL(url: string): Record<string, string[]> {
  const cleanURL = url.replace('?colorScheme=', '').replace('#', '&');
  const parsed = new URL(cleanURL, 'https://example.com/');
  return mapValues(
    qs.parse(parsed.search, {
      ignoreQueryPrefix: true,
    }),
    toFlatArray,
  );
}

function toFlatArray(value) {
  return flatten([value]);
}
